import { useState } from 'react';
import { FormControl } from '@Components/common/FormUI';
import { Controller, useFormContext } from 'react-hook-form';
import hasErrorBoundary from '@Components/common/hasErrorBoundary';
import GroupCheckBox from '@Components/common/FormUI/GroupCheckBox';
import { useQuery } from '@tanstack/react-query';
import { getMarkerList } from '@Services/components';
import { FlexColumn } from '@Components/common/Layouts';
import CheckBoxSkeleton from '@Components/common/FormComponent/CheckBoxSkeleton';
import ErrorMessage from '@Components/common/ErrorMessage';
import useDebouncedInput from '@Hooks/useDebouncedInput';
import Searchbar from '@Components/common/SearchBar';
import isEmpty from '@Utils/isEmpty';

const MarkerComponentForm = () => {
  const [searchMarker, setSearchMarker] = useState('');
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { data: markerList, isFetching } = useQuery({
    queryKey: ['marker', searchMarker],
    queryFn: () => getMarkerList({ search: searchMarker }),
    select: res => {
      if (!res?.data) return [];
      const markerLists = res.data;

      const truthyMarkes = markerLists
        .filter((marker: Record<string, any>) => marker !== null)
        ?.filter((mar: Record<string, any>) => !isEmpty(mar?.marker));

      return truthyMarkes;
    },
  });

  const [value, handleChange] = useDebouncedInput({
    ms: 400,
    init: searchMarker,
    onChange: debouncedEvent => setSearchMarker(debouncedEvent.target.value),
  });

  return (
    <div className="marker-form-container">
      <div className="naxatw-px-6 naxatw-pb-2">
        <Searchbar
          placeholder="Search Marker"
          value={value}
          onChange={handleChange}
          required={false}
        />
        <>
          {
            /* @ts-ignore */
            errors?.marker?.message && (
              <ErrorMessage
                className="naxatw-ml-3 naxatw-mt-2"
                /* @ts-ignore */
                message={errors?.marker?.message}
              />
            )
          }
        </>
      </div>
      <div
        className={`scrollbar naxatw-w-full naxatw-overflow-y-auto naxatw-px-6  ${errors?.marker?.message ? 'naxatw-h-[calc(100vh-520px)] lg:naxatw-h-[calc(100vh-375px)]' : 'naxatw-h-[calc(100vh-520px)] lg:naxatw-h-[calc(100vh-350px)]'}`}
      >
        <FlexColumn className="naxatw-w-full naxatw-space-y-5 ">
          {isFetching ? (
            <CheckBoxSkeleton />
          ) : (
            <>
              <FormControl className="naxatw-w-full naxatw-gap-[0.5rem] ">
                <Controller
                  control={control}
                  name="marker"
                  defaultValue={{}}
                  render={({ field }) => {
                    return (
                      <GroupCheckBox
                        checkedItems={field.value} // Pass the current value of 'marker' to GroupCheckBox
                        onCheckboxChange={newCheckedItems =>
                          field.onChange(newCheckedItems)
                        } // Pass the change handler to update the form state
                        groupData={markerList}
                        subGroupName="marker"
                      />
                    );
                  }}
                />
              </FormControl>
            </>
          )}
        </FlexColumn>
      </div>
    </div>
  );
};

export default hasErrorBoundary(MarkerComponentForm);
